import React, { Component } from 'react';
import { useState } from 'react';
import { ApparelGrid } from '../ApparelGrid';
import { Map } from '../Map';
import Hero1 from '../HeroImage/hero1';
import HeroTextNarrow from '../HeroText/HeroTextNarrow';
import { Footer } from '../Footer';
import { Popup } from '../Popup/popup';

// export class Home extends Component {
export const Home = () => {
    // static displayName = Home.name;
    const showBunner = false;
    const expDate = new Date('2023-04-08');
    const todayDate = new Date();
    const [open, setOpen] = useState(todayDate < expDate);

    const handleClick = () => {
        setOpen(!open);
    };
    // render() {
    return (
        <div>
            {/*<button onClick={() => setOpen(true)}> Click to Open Popup</button>*/}
            { showBunner && < HeroTextNarrow /> }
            {/*<Hero1 />*/}
            <ApparelGrid />
            <Map />
            <Footer />
            {open ? <Popup text={todayDate < expDate} closePopup={() => handleClick()} /> : null}
        </div>
    );
    // }
}

// export default Home;


// WEBPACK FOOTER //
// ./src/components/Pages/Home.js